module.exports = __webpack_public_path__ + "img/text-classify7.52df0e22.png";